export type EasingFn = (t: number) => number;

/** Cubic ease-in-out on a normalised t ∈ [0,1]. */
export const easeInOutCubic: EasingFn = (t) =>
  t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;

/** Cubic ease-out on a normalised t ∈ [0,1]. */
export const easeOutCubic: EasingFn = (t) => 1 - Math.pow(1 - t, 3);

/**
 * Named easing lookup — used by `CameraFlyover` segment configs whose
 * `easing` field is a string key.
 */
export const EASING: Record<string, EasingFn> = {
  linear: (t) => t,
  'ease-in': (t) => t * t * t,
  'ease-out': easeOutCubic,
  'ease-in-out': easeInOutCubic,
};
